<template>
  <div class="receive-gift" v-show="imgReady && !isloading">
    <div class="get" v-if="this.pageData.packageStatus === 'DELIVERING'">
      <div class="gift-box">
        <img class="logo" src="@/assets/img/UgiftLogoTM.png" alt="">
        <img src="@/assets/img/gift-box.png" alt="">
        <div class="open" @click="openGift()">
          {{selfInit ? 'The gift has been given ' : 'Open the Gift'}}
        </div>
      </div>
    </div>
    <div class="gift-content" v-if="pageData.packageStatus !== 'DELIVERING' && !isloading">
      <p class="status gray bold">The gift has been received</p>
      <img class="card-img" :src="pageData.packageImage" alt="">
      <p class="tips">{{text}}</p>
      <div class="fx friend fx-items-center" v-show="pageData.packageImage">
        <img class="pic" :src="friendPic" alt="">
        <div class="info">
          <p>{{friendName}}</p>
          <p>{{pageData.description ? pageData.description : `Send You A Wish with Gift`}}</p>
        </div>
      </div>
    </div>
    <!-- <div class="footer blue fx fx-center">
      <p @click="goPage('home')">I Want to Send a Gift </p>
      <span>|</span>
      <p @click="goPage('myGiftCard')">Check My Ugift Wallet</p>
    </div> -->
    <van-dialog v-model="showDialog" :closeOnClickOverlay="true" :showConfirmButton="false">
      <div class="gift-dialog">
        <van-icon name="close" size="25" @click="hideDailog"/>
        <p class="text-center" v-if="!selfInit">
          {{friendName ? 'You have received a gift card from ' + friendName : 'You have received a gift card'}}
        </p>
        <van-image class="pic" :src="pageData.packageImage" />
        <div class="wish">{{pageData.description ? pageData.description : `Send You A Wish with Gift`}}</div>
        <van-button v-if="!selfInit" type="info" size="large" round @click="checkDetail">Accept</van-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      imgReady: false,
      isloading: true,
      showDialog: false,
      friendName: '',
      friendPic: '',
      fbId: '',
      text: '',
      btnTxt: '',
      pageData: {},
      isCheck: false,
      timer: null,
      packageParams: {
        originalMemberId: '',
        packageId: ''
      },
      transferId: '',
      transferType: '',
      selfInit: false
    }
  },
  created () {
    this.preloadImg()
    const queryParams = this.$route.query

    this.packageParams.orderId = queryParams.orderId
    this.packageParams.originalMemberId = queryParams.memberId
    this.packageParams.packageId = queryParams.packageId

    this.friendName = decodeURIComponent(queryParams.name) || ''
    this.friendPic = decodeURIComponent(window.location.href.split('picture=')[1])

    if (this.packageParams.originalMemberId === this.$util.storageGet('local', 'memberId')) {
      this.selfInit = true
      // alert('本人进入')
      // this.$router.replace('/home')
    }
    this.loadData()
  },
  beforeDestroy () { // 组件销毁前调用
    clearTimeout(this.timer)
  },
  methods: {
    // 查询订单
    getOrderInfoById (params) {
      return this.$http.post('/olvp/getOrderInfoById', 'getOrderInfoById', params, true, false)
    },
    // 转赠领取
    orderVoucherTransfer (params) {
      return this.$http.post('/olvp/orderVoucherTransfer', 'orderVoucherTransfer', params, true, false, false, false)
    },
    // 查看包裹
    getPackageItems (params) {
      return this.$http.post('/olvp/getPackageItems', 'getPackageItems', params, false, false)
    },
    // 图片预加载
    preloadImg () {
      let imgs = [
        require('@/assets/img/gift-bg.jpg'),
        require('@/assets/img/gift-box.png')
      ]

      for (let img of imgs) {
        let image = new Image()
        image.onload = () => {
          this.count++
        }
        image.src = img
        if (image.length === this.count) {
          this.imgReady = true
        }
      }
    },
    loadData () {
      this.getPackageItems(this.packageParams).then((d) => {
        if (d.success) {
          this.pageData = d.content
          // if (this.pageData.packageStatus === 'SUCCESS') {

          // } else {
          //   // this.$router.replace('/home')
          // }
          // 订单转赠
          if (this.pageData.packageName === 'OrderVoucherTransfer') {
            this.transferType = 'order'
            this.transferId = this.packageParams.orderId
          // 单券转赠
          } else {
            this.transferType = 'voucher'
            this.transferId = this.pageData.vouchers[0].voucherId
          }
          this.isloading = false
        }
      })
    },
    hideDailog () {
      this.showDialog = false
    },
    // 跳转查看券详情
    openGift () {
      this.showDialog = true
    },
    checkDetail () {
      this.$router.push(`/couponDetail?type=${this.transferType}&packageId=${this.packageParams.packageId}&voucherId=${this.transferType === 'voucher' ? this.transferId : ''}&orderId=${this.transferType === 'order' ? this.transferId : ''}&memberId=${this.packageParams.originalMemberId}&recevie=true`)
    },
    goPage (e) {
      this.$router.push(`/${e}`)
    }
  }
}
</script>

<style lang="scss">
  .receive-gift {
    width: 100%;
    height: 100%;
    text-align: center;
    position: relative;
    .status {
      text-align: center;
      margin-bottom: 30px;
      font-size: 20px;
    }
    .gift-dialog {
      font-size: 14px;
      padding: 20px;
      .pic {
        margin: 15px 0;
        box-shadow: 5px 5px 10px #dbdbdb;
        border-radius: 8px;
      }
      .wish {
        margin-bottom: 15px;
        word-break:break-all;
        line-height: 20px;
      }
      .van-icon {
        margin-bottom: 10px;
      }
    }
    .get {
      z-index: 99;
      width: 100%;
      height: 100%;
      background: url("../../assets/img/gift-bg.jpg") no-repeat;
      background-size: 100% 100%;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      .gift-box {
        width: 100%;
        position: absolute;
        top: 50%;
        transform:  translate(0, -50%);
        .logo {
          width: 75px;
          height: 75px;
          border-radius: 50%;
          margin: 0 auto;
        }
      }
      .from {
        width: 100%;
        color: #fff;
        position: absolute;
        top: -25px;
        .text-center {
          font-size: 22px;
          margin-top: 15px;
        }
        img {
          width: 30px;
          height: 30px;
          margin-right: 5px;
        }
      }
      .open {
        width: 80%;
        color: #fff;
        font-size: 16px;
        margin: 0 auto;
        text-align: center;
        padding: 15px;
        border-radius: 30px;
        background-image: linear-gradient(to right, #7CC1FF , #087FF7, #238EFF);
        box-shadow: 2px 2px 8px #087FF7;
      }
    }

    .gift-content {
      position: absolute;
      padding: 0 20px;
      top:40%;
      left:50%;
      width:100%;
      transform:translate(-50%,-50%);
      text-align: center;
    }

    .card-img {
      width: 70%;
      border-radius: 8px;
      box-shadow: 5px 5px 15px #ddd;
      margin: 0 auto;
      margin-bottom: 20px;
    }

    .tips {
      text-align: center;
      font-size: 16px;
      margin-bottom: 40px;
    }

    .friend {
      border-top: 1px solid #eee;
      padding-top: 40px;
      box-sizing: border-box;
      .pic {
        width: 40px;
        height: 40px;
        margin-right: 15px;
      }
      .info {
        word-wrap: break-word;
        flex: 2;
        p {
          font-size: 16px;
        }
        p:nth-child(1) {
          margin-bottom: 4px;
        }
      }
    }

    .goods {
      padding: 20px 0;
      .item {
        margin: 10px 0;
      }
    }

    .footer {
      padding: 20px 0;
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      span {
        margin: 0 5px;
      }
    }

  }
</style>
